import { CSSProperties } from 'react';
import { Color } from '@vivli/shared/theme';
import { Outlet } from 'react-router';

export const ListingRequestRoutesComponent = () => {
    const containerStyle: CSSProperties = {
        width: document.documentElement.clientWidth - 231,
        flex: '1 1 auto',
        backgroundColor: Color.LIGHT_GRAY,
        overflowY: 'hidden',
        overflowX: 'hidden',
    };

    return (
        <div className={'listingRequestRouterWrapper'} style={containerStyle}>
            <Outlet />
        </div>
    );
};
